import Splide from "@splidejs/splide";

const gallerySliders = document.querySelectorAll(
  ".gallery_carousel.default, .gallery_carousel.multi, .gallery_carousel.full-width, .no_crop_carousel"
);

gallerySliders.forEach((slider) => {
  const splideSlide = new Splide(slider.querySelector(".splide"), {
    type: "slide",
    omitEnd: true,
    pagination: false,
    speed: 600,
    easing: "ease",
    perPage: 1,
    gap: "3rem",
    trimSpace: false,
    focus: "center",
  });
  splideSlide.mount();

  // Create an element to store current slide when page loads
  const currentSlideInit = splideSlide.root.querySelector(
    ".gallery-current, .no-crop-current"
  );
  const indexPlusOneInit = splideSlide.index + 1;
  currentSlideInit.innerHTML = indexPlusOneInit.toString();

  // Create a dynamic element to store length of carousel
  const totalSlidesEl = splideSlide.root.querySelector(
    ".gallery-total, .no-crop-total"
  );
  totalSlidesEl.innerHTML = splideSlide.length.toString();

  // Hide pagination if there is only one slide
  const paginationEl = splideSlide.root.querySelector(".splide__arrows");
  if (splideSlide.length < 2) {
    paginationEl.classList.add("gallery-pagination--hidden");
  }

  // Event listener to change current slide number each time carousel moves
  splideSlide.on("moved", () => {
    const currentSlideEl = splideSlide.root.querySelector(
      ".gallery-current, .no-crop-current"
    );
    const indexPlusOne = splideSlide.index + 1;
    currentSlideEl.innerHTML = indexPlusOne.toString();
  });
});

const gallerySlidersLeft = document.querySelectorAll(".gallery_carousel.left");

gallerySlidersLeft.forEach((slider) => {
  const splideSlideLeft = new Splide(slider.querySelector(".splide"), {
    type: "fade",
    pagination: false,
  });
  splideSlideLeft.mount();

  // Create an element to store current slide when page loads
  const currentSlideInit =
    splideSlideLeft.root.querySelector(".gallery-current");
  const indexPlusOneInit = splideSlideLeft.index + 1;
  currentSlideInit.innerHTML = indexPlusOneInit.toString();

  // Create a dynamic element to store length of carousel
  const totalSlidesEl = splideSlideLeft.root.querySelector(".gallery-total");
  totalSlidesEl.innerHTML = splideSlideLeft.length.toString();

  // Hide pagination if there is only one slide
  const paginationEl = splideSlideLeft.root.querySelector(".splide__arrows");
  if (splideSlideLeft.length < 2) {
    paginationEl.classList.add("gallery-pagination--hidden");
  }

  // Event listener to change current slide number each time carousel moves
  splideSlideLeft.on("moved", () => {
    const currentSlideEl =
      splideSlideLeft.root.querySelector(".gallery-current");
    const indexPlusOne = splideSlideLeft.index + 1;
    currentSlideEl.innerHTML = indexPlusOne.toString();
  });
});
